// extracted by mini-css-extract-plugin
export default {"title":"styles_title__Gfuh3","blueTitle":"styles_blueTitle__rLyie","rightAligned":"styles_rightAligned__2xBol"};